/* eslint-disable no-console */
/* eslint-disable object-shorthand */
/* eslint-disable no-plusplus */
/* eslint-disable prefer-const */
/* eslint-disable function-paren-newline */
/* eslint-disable comma-dangle */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable quotes */
/* eslint-disable no-unused-vars */
import {
  put,
  takeLatest,
  call,
  all,
  fork,
  takeEvery,
  take,
} from "redux-saga/effects";
import {
  FETCH_ALL_LATEST_PRICE,
  FETCH_LATEST_PRICE,
  FETCH_PRICE_24H,
  FETCH_PRICE_MARKET_24H,
  FETCH_STICK_PRICE,
} from "../actions/price/action_types";

import actions from "../actions/price";
import rf from "../../requests/RequestFactory";

// saga effect

function* fetchAllLatestPrice() {
  try {
    const { data } = yield call(() =>
      rf.getRequest("PriceRequest").fetchAllLatest()
    );
    yield put(actions.fetchAllLatestPriceActionSucceed(data));
  } catch (err) {
    console.error(err);
    yield put(actions.fetchAllLatestPriceActionFailed(err));
  }
}

function* fetchLatestPrice(action) {
  try {
    const { data } = yield call(
      (params) => rf.getRequest("PriceRequest").fetchLatest(params),
      action.params.data
    );
    yield put(actions.fetchLatestPriceActionSucceed(data));
  } catch (err) {
    console.error(err);
    yield put(actions.fetchLatestPriceActionFailed(err));
  }
}

function* fetchPrice24h(action) {
  try {
    const { data } = yield call(
      (params) => rf.getRequest("PriceRequest").fetchPrice24h(params),
      action.params.data
    );
    yield put(actions.fetchPrice24hActionSucceed(data));
  } catch (err) {
    console.error(err);
    yield put(actions.fetchPrice24hActionFailed(err));
  }
}

function* fetchStickPrice(action) {
  try {
    const { data } = yield call(
      (params) => rf.getRequest("PriceRequest").fetchSticks(params),
      action.params.data
    );
    yield put(actions.fetchStickPriceActionSucceed(data));
  } catch (err) {
    console.error(err);
    yield put(actions.fetchStickPriceActionFailed(err));
  }
}

function* fetchPriceMarket24hSaga(action) {
  try {
    let arrCurrencyLightChart = [];
    // console.log(action.params.data);
    for (let i = 0; i < action.params.data.length; i++) {
      let { data } = yield call(
        (coinAndCurrency) =>
          rf.getRequest("PriceRequest").fetchPriceMarket24h(coinAndCurrency),
        action.params.data[i]
      );
      arrCurrencyLightChart.push({
        volume: action.params.data[i].volume,
        coin: action.params.data[i].coin,
        currency: action.params.data[i].currency,
        high: action.params.data[i].high,
        last_price: action.params.data[i].last_price,
        low: action.params.data[i].low,
        change: action.params.data[i].change,
        data: data,
      });
    }
    yield put(actions.fetchPriceMarket24hSucceed(arrCurrencyLightChart));
  } catch (err) {
    console.error(err);
    yield put(actions.fetchStickPriceActionFailed(err));
  }
}

function* watchAllPrices() {
  yield takeLatest(FETCH_ALL_LATEST_PRICE, fetchAllLatestPrice);
  yield takeLatest(FETCH_LATEST_PRICE, fetchLatestPrice);
  yield takeLatest(FETCH_PRICE_24H, fetchPrice24h);
  yield takeLatest(FETCH_STICK_PRICE, fetchStickPrice);
  yield takeLatest(FETCH_PRICE_MARKET_24H, fetchPriceMarket24hSaga);
}

export default function* rootSaga() {
  yield all([fork(watchAllPrices)]);
}
